import { render, staticRenderFns } from "./discounts-code.vue?vue&type=template&id=37d4977f&"
import script from "./discounts-code.vue?vue&type=script&lang=js&"
export * from "./discounts-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports